import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useForgotPassword } from "./auth";
import { AuthShell } from "./authChrome";

export function ForgotPasswordPage() {
  const { t, i18n } = useTranslation("auth");
  const forgot = useForgotPassword();
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    const lang = (i18n.language || "en").slice(0, 2);
    forgot.mutate(
      { email, lang },
      {
        // BE always returns 204 (anti-enumeration) — show the same screen on success.
        onSuccess: () => setDone(true),
        onError: () => setError(t("forgot.error")),
      },
    );
  };

  return (
    <AuthShell backTo="/login" backLabel={t("forgot.back_to_login")}>
      <div className="indigo-card-glass p-6">
        {done ? (
          <div className="space-y-4 text-center">
            <div className="text-[16px] font-semibold text-fg-primary">{t("forgot.done_title")}</div>
            <p className="text-[13px] text-fg-secondary leading-relaxed">{t("forgot.done_text")}</p>
            <Link
              to="/login"
              className="block w-full h-11 leading-[2.75rem] rounded-pill bg-accent hover:bg-accent-hover text-accent-on font-semibold transition-colors"
            >
              {t("forgot.back_to_login")}
            </Link>
          </div>
        ) : (
          <>
            <div className="mb-5">
              <div className="text-[16px] font-semibold text-fg-primary">{t("forgot.title")}</div>
              <p className="mt-1.5 text-[13px] text-fg-secondary leading-relaxed">{t("forgot.subtitle")}</p>
            </div>
            <form onSubmit={submit} className="space-y-3">
              <input
                type="email"
                placeholder={t("email")}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                className="w-full h-11 px-3.5 rounded-pill bg-bg-surface/85 backdrop-blur border border-bg-border focus:border-accent focus:shadow-focus outline-none text-[15px] text-fg-primary placeholder:text-fg-dim transition-shadow"
              />
              {error && (
                <div className="text-[13px] text-bad bg-bad-subtle/30 border border-bad/30 rounded-pill px-3 py-2 leading-snug">
                  {error}
                </div>
              )}
              <button
                type="submit"
                disabled={forgot.isPending}
                className="w-full h-11 rounded-pill bg-accent hover:bg-accent-hover text-accent-on font-semibold disabled:opacity-50 transition-colors"
              >
                {forgot.isPending ? t("forgot.sending") : t("forgot.submit")}
              </button>
            </form>
          </>
        )}
      </div>
    </AuthShell>
  );
}
